import { hostListActions } from '@/actions/hostListActions'

const initialState = {
  list: [],
  params: { page: 1, pageSize: 10 },
  position: 0,
  listNoMore: false
}
export default (state = initialState, { payload, type }) => {
  switch (type) {
    case hostListActions.HOST_LIST:
      return {
        ...state,
        list: payload
      }
    case hostListActions.LIST_PARAMS:
      return {
        ...state,
        params: payload
      }
    case hostListActions.LIST_POSITION:
      return {
        ...state,
        position: payload
      }
    case hostListActions.LIST_NOMORE:
      return {
        ...state,
        listNoMore: payload
      }
    default:
      return state
  }
}
